<template>
  <div :id="page_slug">

    <div class="crumbs-bar">
      <el-row>
        <el-col :span="12">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ name: 'UserList' }">Users</el-breadcrumb-item>
            <el-breadcrumb-item>Edit</el-breadcrumb-item>
          </el-breadcrumb>        
        </el-col>      
      </el-row>
    </div>

    <el-tabs v-model="active_tab" type="card">

      <el-tab-pane label="Basic Information" name="basic_information">
        <el-form ref="user" 
          :model="user" 
          :rules="rules.basic_information"
          :label-position="label_position"
          v-loading="loading">

          <el-form-item>
            <el-switch
              :active-value="1"
              :inactive-value="0"
              active-text="Enabled"
              inactive-text="Disabled"
              v-model="user.status">
            </el-switch>
          </el-form-item>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="First Name" prop="firstName">
                <el-input type="text" v-model="user.firstName"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="Last Name" prop="lastName">
                <el-input type="text" v-model="user.lastName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        
          <el-form-item label="E-Mail" prop="email">
            <el-input type="text" v-model="user.email"></el-input>
          </el-form-item>

          <el-form-item label="Username" prop="login">
            <el-input type="text" :disabled="true" v-model="user.login"></el-input>
          </el-form-item>

          <el-form-item label="Password" prop="password">
            <el-input type="password" v-model="user.password"></el-input>
          </el-form-item>

          <el-form-item label="Supplier" prop="supplier_id">
            <el-select 
              v-model="user.supplier_id" 
              placeholder="Select Supplier"
              :filterable="true"
              :clearable="false"
              value-key="supplier_id">
              <el-option 
                v-for="supplier in suppliers" 
                :key="supplier.id" 
                :label="supplier.name" 
                :value="supplier.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="User Access" prop="user_access_id">
            <el-select 
              v-model="user.user_access_id" 
              placeholder="Select Access"
              :filterable="true"
              :clearable="false"
              value-key="user_access_id">
              <el-option 
                v-for="item in all_user_access" 
                :key="item.id" 
                :label="item.name" 
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="updateUser('user')">Update</el-button>
          </el-form-item>

        </el-form>
      </el-tab-pane>

      <el-tab-pane label="Profile" name="profile">
          <el-form 
            ref="profile" 
            :rules="rules.profile"
            :model="profile"
            :label-position="label_position">

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="Department" prop="department">
                  <el-input type="text" v-model="profile.department"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="Position"  prop="position">
                  <el-input type="text" v-model="profile.position"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
                
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="Telephone" prop="telephone">
                  <el-input type="text" v-model="profile.telephone"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="Mobile" prop="mobile">
                  <el-input type="text" v-model="profile.mobile"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="Fax" prop="fax">
                  <el-input type="text" v-model="profile.fax"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="Address Line 1" prop="address_1">
              <el-input type="text" v-model="profile.address_1"></el-input>
            </el-form-item>

            <el-form-item label="Address Line 2"  prop="address_2">
              <el-input type="text" v-model="profile.address_2"></el-input>
            </el-form-item>

            <el-form-item label="Address Line 3" prop="address_3">
              <el-input type="text" v-model="profile.address_3"></el-input>
            </el-form-item>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="City" prop="city">
                  <el-input type="text" v-model="profile.city"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="Country" prop="country">
                  <el-select  
                    v-model="profile.country"
                    placeholder="Select Country"
                    :clearable="true"
                    filterable>
                    <el-option
                      v-for="item in countries"
                      :key="item.name"
                      :label="item.name"
                      :value="item.name">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="ZIP" prop="zip">
              <el-input type="text" v-model="profile.zip"></el-input>
            </el-form-item>

            <el-form-item>
              <div v-if="profile_exists">
                <el-button type="primary" @click="updateProfile('profile')">Update Profile</el-button>
              </div>

              <div v-else>
                <el-button type="primary" @click="addNewProfile('profile')">Create Profile</el-button>
              </div>
            </el-form-item> 
          </el-form>
      </el-tab-pane>

      <el-tab-pane v-if="can_edit_user_permissions" label="Permissions" name="permissions">
        <el-card 
          hover="never"
          :body-style="{ padding: '0px' }">
          <div slot="header" class="clearfix">
            <el-row>
              <el-col :span="16">
                <el-input
                :clearable="true"
                placeholder="Filter Roles"
                prefix-icon="el-icon-search"
                v-model="filter_roles"></el-input>
              </el-col>
              <el-col :span="6" :offset="2" class="text-right">
                <el-button @click="assignRoles()">Assign Roles</el-button>
              </el-col>
            </el-row>
          </div>
          <div class="scroll-pane">
            <el-checkbox-group v-model="merged_and_selected_roles_ids">
              <el-checkbox v-for="item in all_roles" :disabled="checkDisabled(item)" :label="item.id" :key="item.id" class="checkbox-list">{{item.display_name}}</el-checkbox>
            </el-checkbox-group>
          </div>
        </el-card> 
      </el-tab-pane>
    </el-tabs>

    <pre>{{$data}}</pre>
  </div>
</template>

<style scoped>
  .checkbox-list {
    display:block;
    margin: 0 0 5px 0;
    padding: 0;
  }
</style>

<script>
  import Config from '@/store/Config.js';
  import Utils from '@/components/utils/Utils.js';
  import Auth from '@/components/auth/AuthCheck.js';
  import CountryList from '@/components/utils/CountryList.js';
  import store from '@/store/Store.js';

  export default {
    data: function() {
      return { 
        page_alias: 'Profule',
        page_slug: 'profile',
        
        permissions: store.permissions,
        config: Config.config,

        loading: true,
        label_position: 'top',
        active_tab: 'basic_information',
        can_edit_user_permissions: true,

        jwt: {},
        
        /* FIRST TAB */
        user: {
          user_profile: {},
          
          user_access: {
            user_roles: []
          }
        },

        suppliers: [],
        all_user_access: [],

        /* SECOND TAB */
        profile_exists: false,
        profile: {},

        /* THIRD TAB */
        all_roles: [],
        merged_and_selected_roles: [],
        merged_and_selected_roles_ids: [],
        filter_roles: '',

        rules: {
          basic_information: {
            firstName: [
              {required: true, message: 'Please Enter First Name', trigger: 'blur'}
            ],
            lastName: [
              {required: true, message: 'Please Enter Last Name', trigger: 'blur'}
            ],
            email: [
              {required: true, message: 'Please Enter E-Mail', trigger: 'blur'},
              {type: 'email', message: 'Please Enter Valid E-Mail', trigger: 'blur'}
            ]
          },

          profile: {
            department: [
              {required: true, message: 'Please Enter Department', trigger: 'blur'}
            ],  
            position: [
              {required: true, message: 'Please Enter state', trigger: 'blur'}
            ],  
            address_1: [
              {required: true, message: 'Please Enter Address 1', trigger: 'blur'}
            ],                
            city: [
              {required: true, message: 'Please Enter City', trigger: 'blur'}
            ],  
            country: [
              {required: true, message: 'Please Select Country', trigger: 'blur'}
            ],  
            mobile: [
              {required: true, message: 'Please Enter Mobile Number', trigger: 'blur'}
            ]
          }
        },
         countries: CountryList.countries,
      };
    },

    mounted: function() {
      const me = this;
      me.jwt = Utils.decodejwt();

      me.getUser();
      me.getAllUserAccess();
      me.getSuppliers();

      me.getRoles();
    },

    computed: {
      filteredRoles() {
        const me = this;
        return me.roles.filter(function(e){return e.name.toLowerCase().indexOf(me.filter_roles.toLowerCase())>=0;});
      }
    },

    methods: {
      /* FIRST TAB */
      getUser: function() {
        console.log('Get User Function');
        const me = this;

        me.$http.get(me.config.api + 'user/{id}', {params: {id: me.$route.params.id}}).then(
        response => {
          console.log('Get User Function - Success Getting Data')  

          me.user = response.body.data;

          /* makes a combined array of the user roles and access roles */
          me.merged_and_selected_roles = _.concat(me.user.user_access.user_roles, me.user.user_roles);

          /* this is needed for when you change someone's access level - it avoids 
          adding roles to a user they already have through their access roles */
          me.merged_and_selected_roles = _.uniqBy(me.merged_and_selected_roles, 'id');

          /* takes all the merged roles and makes an array of their IDs (i.e. [1,23,28,30]) */
          me.merged_and_selected_roles_ids = me.merged_and_selected_roles.map(a => a.id);

          if(me.user.user_profile != null) {
            me.profile_exists = true;
            me.profile = me.user.user_profile;
          }

          me.loading = false;
        }, response => {
          console.log('Get User Function - Error Getting Data');

          me.loading = false;
        });
      },

      getSuppliers: function() {
        console.log('Get Suppliers Function');
        const me = this;

        me.$http.get(me.config.api + 'supplier', {params: {pagination: 1000}}).then(
          response => {
          console.log('Get Suppliers Function - Success Getting Data')  

          me.suppliers = response.body.data;
        }, response => {
          console.log('Get Suppliers Function - Error Getting Data');
        });
      },

      getAllUserAccess: function() {
        console.log('Get All User Access Function');
        const me = this;

        me.$http.get(me.config.api + 'access', {params: {no_roles: 1}}).then(
          response => {
          console.log('Get All User Access Function - Success Getting Data');

          me.all_user_access = response.body.data;
        }, response => {
          console.log('Get All User Access Function - Error Getting Data');
        });
      },

      updateUser: function(formName) {
        console.log('Update User Function');
        const me = this;

        me.$refs[formName].validate((valid) => {
          if(valid) {
            me.user.updated_user_id = me.jwt.sub;

            me.$http.put(me.config.api + 'user/{id}', me.user, {params: {id: me.$route.params.id}}).then(
              response => {
              console.log('Update User Function - Success Putting Data')  

              me.getUser();

              me.$notify({
                title: 'Success',
                message: 'The User Was Updated',
                type: 'success'
              });
            }, response => {
              console.log('Update User Function - Error Putting Data');
            });
          } else {
            console.log('Fields Not Valid');
            return false;
          }
        });
      },
      /* END FIRST TAB */


      /* SECOND TAB */
      updateProfile: function(formName) {
        console.log('Update Profile Function');
        const me = this;

        me.$refs[formName].validate((valid) => {
          if(valid) {
            me.user.updated_user_id = me.jwt.sub;

            me.$http.put(me.config.api + 'user/{id}/profile/{pid}', me.profile, {params: {id: me.$route.params.id, pid: me.user.user_profile.id}}).then(
              response => {
              console.log('Update Profile Function - Success Putting Data')  

              me.getUser();

              me.$notify({
                title: 'Success',
                message: 'The Profile Was Updated',
                type: 'success'
              });
            }, response => {
              console.log('Update Profile Function - Error Putting Data');
            });
          } else {
            console.log('Fields Not Valid');
            return false;
          }
        });
      },

      addNewProfile: function(formName) {
        console.log('Add New Profile Function');
        const me = this;

        me.$refs[formName].validate((valid) => {
          if(valid) {
            me.profile.user_id = me.jwt.sub;

            me.$http.post(me.config.api + 'user/{id}/profile', me.profile, {params: {id: me.$route.params.id}}).then(
              response => {
              console.log('Add New Profile Function - Success Putting Data')  

              me.$notify({
                title: 'Success',
                message: 'The Profile Was Created',
                type: 'success'
              });

              me.getUser();
            }, response => {
              console.log('Add New Profile Function - Error Putting Data');
            });
          } else {
            console.log('Fields Not Valid');
            return false;
          }
        });
      },
      /* END SECOND TAB */


      /* THIRD TAB */
      checkDisabled: function(role) {
        console.log('Check Disabled Function');
        const me = this;

        if(me.user.user_access.user_roles.length > 0) {

          var found_role = me.user.user_access.user_roles.some(function (el) {
            return el.id === role.id
          });

          if(found_role) {
            return true;
          }
        }

        return false;
      },

      getRoles: function() {
        console.log('Get Roles Function');
        const me = this;

        me.$http.get(me.config.api + 'roles', {params: {pagination: 1000}}).then(
          response => {
          console.log('Get Roles Function - Success Getting Data');

          me.all_roles = response.body.data;
        }, response => {
          console.log('Get Roles Function - Error Getting Data');
        });
      },

      assignRoles: function(){
        console.log('Assign Roles Function');
        const me = this;
    
        //me.loading.adding_roles = true;

        /* this is needed for when you change someone's access  
        level - it avoids adding roles to a user they already
        have through their access roles */
        
        var access_roles_ids = me.user.user_access.user_roles.map(a => a.id);

        var roles = me.merged_and_selected_roles_ids.filter(function(el) {
          return !access_roles_ids.includes(el);
        });
      
        me.$http.post(me.config.api + 'user/{id}/role', roles, {params: {id: me.$route.params.id}}).then(
          response => {
          console.log('Assign Roles Function - Success Posting Data');

          me.$notify({
            title: 'Success',
            message: 'The roles were successfully assigned',
            type: 'success'
          });

          me.getUser();

          //me.loading.adding_roles = false;
        }, response => {
          console.log('Assign Roles Function - Error Posting Data');

          //me.loading.adding_roles = false;
        });
      },
      /* END THIRD TAB */

    }
  }
</script>





// WEBPACK FOOTER //
// src/pages/users/UserEdit.vue